import React from 'react';

import {reduxForm} from 'redux-form'

import AddressForm from '../../components/forms/AddressForm'

import {validateBillingAddress as validate} from '../../util/validate'

function BillingAddressForm(props) {
    return <AddressForm id="billingAdress" showTaxID={false} {...props} />;
}


BillingAddressForm = reduxForm({form: 'billingAddress', destroyOnUnmount: false, validate})(BillingAddressForm)// eslint-disable-line

export default BillingAddressForm


/** WEBPACK FOOTER **
 ** ./src/containers/clientdata/BillingAddressForm.js
 **/